/* The bolt hole wizard (snippets/bolt-holes.liquid). window.TPBoltHoles.open({ from, cart, onApply }) asks, one step
   at a time: the kind of fastener; then a bolt's or lag screw's size, a structural screw's brand and model (a search
   filters them as the customer types), or a hole size outright; then shows the hole, why, and any caveat; and, on a
   plate page, whether it is for this plate or every flat plate on the order. onApply gets the answer:
   { d: 0.5625, hole: '9/16"', value: '9/16" (for 1/2" bolts)', stock: false, scope: 'this' | 'order' }.

   For the order, the answer is kept on the cart (the hidden attribute _bolt_holes, "0.5625|9/16" (for 1/2" bolts)",
   empty for stock) and every flat plate line already in the cart is rewritten to it, one /cart/change.js at a time:
   its "Bolt holes" words and its _spec set, or both taken off for stock. A flat plate is a line whose SKU names one of
   the six plate collections and is not a saddle (-WS), as the Forge back office reads it. Nothing else is touched. */
(() => {
  const dlg = document.querySelector('[data-bolt-holes]');
  const data = (() => { try { return JSON.parse(dlg?.querySelector('[data-bolt-holes-json]')?.textContent || 'null'); } catch { return null; } })();
  if (!dlg || !data) return;
  // the words come from the locale through | t, which escapes them for HTML: read back as plain text (the two _html ones stay HTML)
  const plain = v => { if (typeof v !== 'string') return v; const d = document.createElement('textarea'); d.innerHTML = v; return d.value; };
  for (const k of Object.keys(data.t)) if (k !== 'ask') data.t[k] = plain(data.t[k]);
  for (const sc of data.screws) for (const k of ['brand', 'name', 'what', 'why']) sc[k] = plain(sc[k]);
  data.unrated = data.unrated || [];
  for (const u of data.unrated) for (const k of ['brand', 'name']) u[k] = plain(u[k]);
  const T = data.t, body = dlg.querySelector('[data-bh-body]'), STOCK = data.stock;
  const label = d => (data.holes.find(h => Math.abs(h[0] - d) < 1e-6) || [d, `${d}"`])[1];
  const PLATE = /^(Cornice|Taiga|Cuesta|Massif|Esker|Sierra)-/;
  const flat = sku => PLATE.test(sku || '') && !String(sku).includes('-WS');
  const spec = d => JSON.stringify({ configurator: 'stock-plate', version: 2, hole_diameter: d });
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

  let opts = {}, stack = [], answer = null, scope = 'this', opener = null;

  // The answer for a hole, and what the customer reads on the line ("9/16" (for 1/2" bolts)", or the hole alone)
  function answerFor(d, what, extra = {}) {
    const hole = label(d);
    return { d, hole, value: what ? T.value.replace('%h', hole).replace('%w', what) : T.valueBare.replace('%h', hole), stock: Math.abs(d - STOCK) < 1e-6, ...extra };
  }

  /* the steps */
  function show(step, push = true) {
    if (push) stack.push(step);
    body.replaceChildren(...step());
    (body.querySelector('.bh-search') || body.querySelector('.bh-opt, .bh-back, button'))?.focus({ preventScroll: true });
  }
  function back() {
    stack.pop();
    const prev = stack[stack.length - 1];
    if (prev) show(prev, false);
  }
  const option = (value, note, onPick) => {
    const b = el('button', 'bh-opt');
    b.type = 'button';
    b.append(el('span', 'bh-o-v', value));
    if (note) b.append(el('span', 'bh-o-n', note));
    b.addEventListener('click', onPick);
    return b;
  };
  const backButton = () => { const b = el('button', 'bh-back', T.back); b.type = 'button'; b.addEventListener('click', back); return b; };
  const acts = (...kids) => { const a = el('div', 'bh-acts'); a.append(...kids); return a; };

  const kind = () => {
    const list = el('div', 'bh-list');
    list.append(
      option(T.kind_bolt, T.kind_bolt_n, () => show(sizes('bolt'))),
      option(T.kind_lag, T.kind_lag_n, () => show(sizes('lag'))),
      option(T.kind_screw, T.kind_screw_n, () => show(brands)),
      option(T.kind_hole, T.kind_hole_n, () => show(holes)),
    );
    return [el('p', 'bh-q', T.q_kind), list];
  };

  const sizes = what => () => {
    const list = el('div', 'bh-list bh-sizes');
    for (const [size, d] of data.bolts) {
      const words = (what === 'bolt' ? T.whatBolt : T.whatLag).replace('%s', size);
      list.append(option(size, T.holeOf.replace('%s', label(d)), () => show(result(answerFor(d, words, { bolt: size })))));
    }
    const out = [el('p', 'bh-q', what === 'bolt' ? T.q_bolt : T.q_lag), list];
    if (what === 'bolt') out.push(el('p', 'bh-note', T.carriage));
    return [...out, acts(backButton())];
  };

  // brands, and every screw at once once the customer types: what they typed, in the brand or the screw's name
  const brands = () => {
    const search = el('input', 'bh-search');
    search.type = 'search';
    search.placeholder = T.search;
    search.setAttribute('aria-label', T.search);
    const list = el('div', 'bh-list');
    const none = el('p', 'bh-note', T.no_match);
    const draw = () => {
      const q = search.value.trim().toLowerCase();
      list.replaceChildren();
      if (!q) {
        for (const b of [...new Set([...data.screws, ...data.unrated].map(s => s.brand))]) list.append(option(b, null, () => show(models(b))));
      } else {
        const hit = s => `${s.brand} ${s.name}`.toLowerCase().includes(q);
        for (const s of data.screws.filter(hit)) list.append(option(s.name, s.brand, () => show(result(answerFor(s.hole, s.what, { why: s.why, caveat: s.caveat })))));
        for (const u of data.unrated.filter(hit)) list.append(option(u.name, `${u.brand} · ${u.why === 'ozco' ? T.noAnswer : T.notRated}`, () => show(unrated(u))));
      }
      list.hidden = !list.children.length;
      none.hidden = !!list.children.length;
    };
    search.addEventListener('input', draw);
    draw();
    const other = el('div', 'bh-list');
    other.append(option(T.not_listed, null, () => show(holes)));
    return [el('p', 'bh-q', T.q_brand), search, list, none, other, acts(backButton())];
  };

  const models = brand => () => {
    const list = el('div', 'bh-list');
    for (const s of data.screws.filter(s => s.brand === brand)) {
      list.append(option(s.name, T.holeOf.replace('%s', label(s.hole)), () => show(result(answerFor(s.hole, s.what, { why: s.why, caveat: s.caveat })))));
    }
    for (const u of data.unrated.filter(u => u.brand === brand)) list.append(option(u.name, u.why === 'ozco' ? T.noAnswer : T.notRated, () => show(unrated(u))));
    const other = el('div', 'bh-list');
    other.append(option(T.not_listed, null, () => show(holes)));
    return [el('p', 'bh-q', T.qModel.replace('%b', brand)), list, other, acts(backButton())];
  };

  // a screw we give no hole for: rated for wood-to-wood only, or OZCO's, whose sizes are unpublished; the customer may still choose a hole
  const unrated = u => () => {
    const box = el('div', 'bh-result');
    box.append(el('span', 'bh-r-v', u.name), el('span', 'bh-r-n', u.brand));
    const pick = el('div', 'bh-list');
    pick.append(option(T.chooseHole, null, () => show(holes)));
    return [box, el('p', 'bh-caveat', u.why === 'ozco' ? T.unratedOzco : T.unratedWood.replace('%n', u.name)), pick, acts(backButton())];
  };

  const holes = () => {
    const list = el('div', 'bh-list bh-sizes');
    for (const [d, h] of data.holes) list.append(option(h, Math.abs(d - STOCK) < 1e-6 ? T.stock : null, () => show(result(answerFor(d, null)))));
    const out = [el('p', 'bh-q', T.q_hole), el('p', 'bh-note', T.hole_hint), list];
    if (T.ask) { const ask = el('p', 'bh-note'); ask.innerHTML = T.ask; out.push(ask); }
    return [...out, acts(backButton())];
  };

  const result = a => () => {
    answer = a;
    const box = el('div', 'bh-result');
    box.append(el('span', 'bh-r-v', T.result.replace('%h', a.hole)), el('span', 'bh-r-n', a.stock ? T.result_stock : a.value));
    if (a.why) box.append(el('span', 'bh-r-n', a.why));
    const out = [box];
    if (a.caveat) { const c = el('p', 'bh-caveat'); c.innerHTML = a.caveat; out.push(c); }
    const msg = el('p', 'bh-note');
    if (!opts.cart) {
      // this plate, or every flat plate on the order
      out.push(el('p', 'bh-q', T.q_scope));
      const list = el('div', 'bh-list');
      const pick = which => {
        scope = which;
        for (const b of list.children) b.setAttribute('aria-pressed', String(b.dataset.scope === which));
        msg.textContent = '';
        if (which === 'order') counted(a).then(text => { if (scope === 'order') msg.textContent = text; });
      };
      for (const [which, v, n] of [['this', T.scope_this, T.scope_this_n], ['order', T.scope_order, T.scope_order_n]]) {
        const b = option(v, n, () => pick(which));
        b.dataset.scope = which;
        list.append(b);
      }
      out.push(list, el('p', 'bh-note', T.scope_note), msg);
      pick(scope);
    } else {
      scope = 'order';
      out.push(el('p', 'bh-note', T.scope_note), msg);
      counted(a).then(text => { msg.textContent = text; });
    }
    const go = el('button', 'btn', T.apply);
    go.type = 'button';
    const err = el('p', 'bh-err');
    err.setAttribute('role', 'alert');
    go.addEventListener('click', async () => {
      go.disabled = true;
      go.textContent = T.applying;
      err.textContent = '';
      try {
        if (scope === 'order') await applyToOrder(a);
        dlg.close();
        opts.onApply?.({ ...a, scope });
      } catch {
        err.textContent = T.failed;
        go.disabled = false;
        go.textContent = T.apply;
      }
    });
    return [...out, acts(backButton(), go), err];
  };

  /* the cart */
  const json = (url, body) => fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(r => { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const holds = (props, a) => (a.stock ? !props?.[T.line_name] && !props?._spec : props?._spec === spec(a.d) && props?.[T.line_name] === a.value);

  // "This changes the 3 flat plates in your cart. That includes 1 plate you set on its own."
  async function counted(a) {
    try {
      const cart = await json(`${root}cart.js`);
      const lines = cart.items.filter(i => flat(i.sku));
      const n = lines.reduce((s, i) => s + i.quantity, 0);
      if (!n) return '';
      const kept = (cart.attributes?._bolt_holes || '').split('|')[0];
      const own = lines.filter(i => i.properties?._spec && !(kept && i.properties._spec === spec(Number(kept)))).reduce((s, i) => s + i.quantity, 0);
      let text = n === 1 ? T.changesOne : T.changesOther.replace('1234567', n);
      if (own && !holds({}, a)) text += ` ${own === 1 ? T.ownOne : T.ownOther.replace('1234567', own)}`;
      return text;
    } catch { return ''; }
  }

  async function applyToOrder(a) {
    await json(`${root}cart/update.js`, { attributes: { _bolt_holes: a.stock ? '' : `${a.d}|${a.value}` } });
    // one line at a time, the cart read again after each: a changed line takes a new key, and may join another
    for (let guard = 0; guard < 100; guard++) {
      const cart = await json(`${root}cart.js`);
      const line = cart.items.find(i => flat(i.sku) && !holds(i.properties, a));
      if (!line) return;
      const props = { ...(line.properties || {}) };
      delete props[T.line_name];
      delete props._spec;
      if (!a.stock) {
        props[T.line_name] = a.value;
        props._spec = spec(a.d);
        await json(`${root}cart/change.js`, { id: line.key, quantity: line.quantity, properties: props });
      } else {
        // back to stock: a change cannot take properties off a line, so the line goes and the plate comes back without them
        await json(`${root}cart/change.js`, { id: line.key, quantity: 0 });
        await json(`${root}cart/add.js`, { items: [{ id: line.variant_id, quantity: line.quantity, ...(Object.keys(props).length ? { properties: props } : {}) }] });
      }
    }
    throw new Error('the cart would not settle');
  }

  /* the dialog */
  dlg.addEventListener('close', () => { opener?.focus?.({ preventScroll: true }); opener = null; });
  dlg.addEventListener('click', e => {
    if (e.target.closest('[data-bh-close]')) { dlg.close(); return; }
    if (e.target !== dlg) return;
    const r = dlg.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
  });

  window.TPBoltHoles = {
    // a hole's answer by its diameter, as the page draws it ("9/16"", "9/16" (for ...)"), and what a cart line carries
    answerFor, label, spec, name: T.line_name, stock: STOCK,
    open(o = {}) {
      opts = { cart: dlg.hasAttribute('data-cart'), ...o };
      opener = o.from || document.activeElement;
      stack = [];
      scope = 'this';
      answer = null;
      if (!dlg.open) dlg.showModal();
      show(kind);
    },
  };
  // the cart's Change: the order's holes, then the cart again, its lines rewritten
  for (const b of document.querySelectorAll('[data-cart-holes]')) {
    b.disabled = false;
    b.addEventListener('click', () => window.TPBoltHoles.open({ from: b, cart: true, onApply: () => location.reload() }));
  }
  document.dispatchEvent(new Event('tp:bolt-holes'));
})();
